<template>
	<page class="vehicle-list" title="Log">
		<input class="tool-text" placeholder="Medarbejder" type="text" slot="tools" v-model="src.employee" />
		<input class="tool-text" placeholder="Ordre nummer" type="text" slot="tools" v-model="src.order_no" />
		<input class="tool-text" placeholder="Opgave nummer" type="text" slot="tools" v-model="src.task_no" />
		<input class="tool-text" placeholder="Henvendelsesnummer" type="text" slot="tools" v-model="src.lead_no" />
		<button-view slot="tools" label="Søg" @click="update()" />
		<new-table-view ref="table" :columns="[
			{
				label: 'Tidspunkt',
				name: 'created',
				filter: 'timestamp'
			},
			{
				label: 'Medarbejder',
				name: 'name'
			},
			{
				label: 'Emne',
				name: 'object'
			},
			{
				label: 'Handling',
				name: 'action'
			},
			{
				label: 'Tilbud',
				name: 'quote_num'
			},
			{
				label: 'Ordre',
				name: 'order_num'
			},
			{
				label: 'Opgave',
				name: 'task_num'
			},
			{
				label: 'Henvendelse',
				name: 'lead_num'
			}
		]" :items="items" @itemClick="itemClick" @delete="itemDelete" @action="action" :actions="actions" />
	</page>
</template>

<script>
	import Window from '../windows/VehicleWindow'
	import NewTableView from '../views/NewTableView'

	import { bus } from '../../bus'

    export default {
		props: [],
		components: {
			newTableView: NewTableView
		},
		methods: {
			createButtonClick: function () {
				var contacts = this;

				this.$store.state.windowStack.push(Window, {
					onChange: function (ent) {
						
						

						contacts.update();
					}
				});
			},
			itemClick: function (item) {
				return;

				var contacts = this;

				this.$store.state.windowStack.push(Window, {id: item.id, form: true, onChange: function () {
					contacts.update();
				}});
			},
			itemDelete(item) {
				if (!confirm('Sikker?')) return;

				var view = this;

				this.axios
					.delete('/fleet/vehicles/' + item.id + '/')
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							view.update();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			action: function (name, id) {
				if (name == 'delete' && confirm('Sure?')) {
					

					var contacts = this;

					this.axios
						.delete('/fleet/vehicles/' + id + '/')
						.then(function () {
							contacts.update();
						}, function () {
							alert('Could not delete the item');
						});
				}
			},
			update() {
				var contacts = this;

				contacts.items = null;

				this.axios
					.get('/log/?employee=' + encodeURI(this.src.employee) + '&quote_no=' + encodeURI(this.src.quote_no) + '&order_no=' + encodeURI(this.src.order_no) + '&task_no=' + encodeURI(this.src.task_no) + '&lead_no=' + encodeURI(this.src.lead_no))
					.then(function (r) {
						
						contacts.items = r.data._items;
					});
			}
		},
		data: function () {
			return {
				src: {
					employee: '',
					order_no: '',
					quote_no: '',
					task_no: '',
					lead_no: ''
				},
				items: [],
				columns: [],
				actions: [
					{name: 'delete', label: 'Delete'}
				]
			};
		},
		mounted: function () {
			this.axios.put('/activity/log/');

			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				
			});


			/*this.axios
				.all([
					this.axios.get('/contacts/'),
					this.axios.get('/contacts/columns/')
				]).then(function (results) {
					
				});*/
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.button {
		float: left;
		margin-left: 10px;
	}
</style>